import { useState, useEffect } from "react";
import { useSingleton } from "../../hooks/use-singleton";
import { useApi } from "../../hooks/use-api";
import { API_USER_DASHBOARD } from "../../utils/api-routes";
import { useCommonDashboard } from "../../hooks/common/dashboard";

const useHandler = () => {
  const { user, mail } = useSingleton();
  const { post } = useApi();
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const {
    learningRes,
    showGoalModal,
    showSuccessModal,
    showViewChallenge,
    learningChallengeCreate,
    setShowGoalModal,
    setShowSuccessModal,
    setShowViewChallenge,
  } = useCommonDashboard();

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const payload = {
          mail: mail,
        };
        const response = await post(API_USER_DASHBOARD, payload);
        setDashboardData(response.data);
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      } finally {
        setLoading(false);
      }
    };

    if (mail) {
      fetchDashboardData();
    }
  }, []);

  return {
    user,
    dashboardData,
    loading,
  };
};

export default useHandler;
